import { combineTokens } from '@utils/css';

const tokens = combineTokens("--fraction-input", {
  x: 0,
  y: 0,
  scale: 1
});
const wrapper = "_35sw1o5pb06";
const stateBox = "_35ssv1gv83";
const readonlyNumber = "_35srvsrrcj";
const fraction = "_35sf4u4dz5";
const readonlyFractionValue = "_35sr1gik3sv";

export { fraction, readonlyFractionValue, readonlyNumber, stateBox, tokens, wrapper };
import "./input.fraction.style.linaria.module.css";
//# sourceMappingURL=input.fraction.style.js.map
